import { inject, Injectable } from '@angular/core';
import { SessionStorageService } from '../../../session-storage/session-storage.service';

@Injectable({
  providedIn: 'root',
})
export class UtmStorageService {
  private key = 'utm-params';

  private sessionStorageService = inject(SessionStorageService);

  get(): Record<string, string> | null {
    try {
      return JSON.parse(this.sessionStorageService.get(this.key));
    } catch (error) {
      return null;
    }
  }

  set(utmParams: Record<string, string>) {
    this.sessionStorageService.set(this.key, utmParams);
  }

  remove() {
    this.sessionStorageService.remove(this.key);
  }
}
